<template lang="html">
  <section class="app-read-project" role="tablist">
    <b-card no-body class="mb-1" :key="idx" v-for="(project, idx) in projects">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="" v-b-toggle="'accordion-'+idx" variant="light">{{project.title}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="d-flex">
<!--            <img :src="encodeURI(getBaseURL + project.src)" :alt="project.title" class="img-fluid img-thumbnail w-25">-->
            <div class="d-flex flex-wrap justify-content-between">
              <div><strong>project_id : </strong>{{project.project_id}}</div>
              <div><strong>project_type_id : </strong>{{project.project_type_id}}</div>
              <div><strong>title : </strong>{{project.title}}</div>
              <div><strong>date_created : </strong>{{project.date_created}}</div>
              <div><strong>date_updated : </strong>{{project.date_updated}}</div>
              <div><strong>link_project : </strong>{{project.link_project}}</div>
              <div><strong>link_overview : </strong>{{project.link_overview}}</div>
              <div><strong>description : </strong>{{project.description}}</div>
              <div><strong>teammates : </strong>{{project.teammates}}</div>
            </div>
          </b-card-text>
          <b-card-text class="mt-4 text-center">
            <button type="button" class="btn btn-primary"
                    @click="navigateAway({id: project.project_id, title: project.title}, 'update')">
              Update
            </button>
            <button type="button" class="btn btn-danger ml-3"
                    @click="navigateAway({id: project.project_id, title: project.title}, 'delete')">
              Delete
            </button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default {
  name: 'ReadProject',
  props: [],
  mounted () {},
  created () {
    this.readData()
      .then(data => this.projects = data)
      .catch()
  },
  data () {
    return {
      projects: null
    }
  },
  methods: {
    ...mapActions([
      'setCurrentElement',
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'readData'
    ]),
    navigateAway(object, tab) {
      this.setCurrentElement(object);
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentElement',
      'getOperation',
      'getComponent',
      'getBaseURL'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-read-project {}
</style>



// WEBPACK FOOTER //
// src/components/projects/ReadProject.vue